import { Container } from "./styles";
import digitalmarketing from "../../assets/digital-marketing.png"
import ScrollAnimation from "react-animate-on-scroll";
import Resume from '../../assets/Shalaka_Wadekar_Social_Media_CV.pdf'

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
          I’m a marketing professional with over four years of experience leading integrated digital campaigns, driving brand visibility, and scaling audiences across global markets.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000} style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <p>
          I hold an MBA in International Marketing from Coventry University, London, UK and a Bachelor’s in Information Technology from Mumbai University. I combine advanced analytical skills with creative storytelling to deliver campaigns that resonate and convert.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>
          <p>
          I’ve partnered with brands across an extensive mix of industries - education, FMCG, entertainment, beauty, retail, wellness, and industrial manufacturing—developing multi-channel campaigns tailored to different audiences. This cross-sector experience fuels my creative thinking and strengthens my ability to deliver meaningful, measurable growth.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={400}>
          <div className="education">
            <h3>Education:</h3>
            <h4>MBA, International Marketing</h4>
            <p>Coventry University, London</p>
            <h4>BSc IT</h4>
            <p>Mumbai University</p>
            <h4>CMI Level 7 Diploma in Strategic Management & Leadership Practice</h4>
          </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={450}>
          <a href={Resume} download className="button">
            Download Resume
          </a>
        </ScrollAnimation>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.21 * 1000}>
          <img src={digitalmarketing} alt="Shalaka Wadekar"
          style={{ transform: "scale(1.1)" }} />
        </ScrollAnimation>
      </div>
    </Container>
  )
}
